<template>
  <label class="radio-container">
    <input
      type="radio"
      v-bind="$attrs"
      :value="value"
      :checked="isChecked"
      v-on="listeners"
    />
    <span class="radio-text">
      <slot>
        {{ label }}
      </slot>
    </span>
    <span class="checkmark" :class="{ 'checkmark--error': error }"></span>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: String,
    value: {},
    radioValue: {
      required: true,
    },
    error: Boolean,
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: () => this.$emit('input', this.radioValue),
        click: () => this.$emit('input', this.radioValue),
      };
    },
    isChecked() {
      return this.radioValue == this.value;
    },
  },
};
</script>

<style></style>
